import './scripts/main';
import { setupForm } from './scripts/forms';
import { createSwiper, setupCardDeckSwiperForMobile } from './scripts/swipers';
import { setupPageLoadCallback, isTablet, isMobile, setupResponsiveCallback } from './scripts/utils';
import { setupFaqBlock } from './scripts/faq_block';

const $freeQuoteForm = $('#free-quote-form');
setupFaqBlock('.faq-block-outer');
setupForm($freeQuoteForm, $freeQuoteForm.find('.thank-you-overlay'));

let processSwiper = null;

function resetProcessContainer() {
  $('.process-item').removeClass('active swiper-slide-active');
  $('.process-item:first-child').addClass('active swiper-slide-active');
}

function setupProcessContainer() {
  const $container = $('#process-swiper');
  const $wrapper = $('#process-swiper-wrapper');

  resetProcessContainer();

  $container.toggleClass('swiper-container card-deck-swiper', isMobile());
  $wrapper.toggleClass('swiper-wrapper card-deck', isMobile());
  $container.find('.process-item').toggleClass('card swiper-slide', isMobile());

  if (isMobile()) {
    if (!processSwiper) {
      processSwiper = createSwiper('#process-swiper', { spaceBetween: 0 });
    }
  } else {
    if (processSwiper !== null) {
      processSwiper.destroy();
      processSwiper = null;
    }
  }
}

function deactivateSteps() {
  $('#process-desktop .process-step').removeClass('active');
  $('#process-desktop .process-description').removeClass('shown');
}

function activateStep(step) {
  deactivateSteps();

  $(step).addClass('active');
  $($(step).attr('href')).addClass('shown');
}

$('#process-desktop .process-step').on('click', function(e) {
  e.preventDefault();
});
$('#process-desktop .process-step').hover(function () {
  activateStep(this);
});

setupPageLoadCallback(() => {
  createSwiper($('#lms-swiper'), {
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-control-next',
      prevEl: '.swiper-control-prev',
    },
    spaceBetween: isTablet() ? 20 : 80,
  });
});

setupCardDeckSwiperForMobile('#cases-swiper');
setupResponsiveCallback(setupProcessContainer);
